export const CONTAINER_SM_MAX_WIDTH = 'am-lg:container am-lg:max-w-xl px-4';

export const CONTAINER_MD_MAX_WIDTH = 'am-lg:container am-lg:max-w-196 pb-4 px-4';

export const CONTAINER_LG_MAX_WIDTH = 'am-lg:container am-lg:max-w-220 pb-4 px-4';

export const CONTAINER_XL_MAX_WIDTH = 'am-lg:container am-lg:max-w-270 px-4';

export const UNSELECTED_SHADOW = 'shadow-box-sm';
export const SELECTED_SHADOW = 'shadow-box-xl';

export const CHECKBOX_UNCHECKED = `bg-white ${UNSELECTED_SHADOW} border-teal-300 border hover:bg-plum-100 hover:border-transparent`;
export const CHECKBOX_CHECKED = `border border-teal-500 bg-mint-100 hover:bg-mint-100 hover:border-teal-500 ${SELECTED_SHADOW}`;
